var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1247 6.71913C1.69343 6.37412 1.06414 6.44404 0.719131 6.87531C0.374122 7.30657 0.444043 7.93586 0.875305 8.28087L2.1247 6.71913ZM5.02642 10.3211L4.40173 11.102H4.40173L5.02642 10.3211ZM7.7624 10.0973L7.01911 9.42837L7.7624 10.0973ZM16.2433 2.16896C16.6128 1.75845 16.5795 1.12616 16.169 0.756706C15.7585 0.387247 15.1262 0.420525 14.7567 0.831035L16.2433 2.16896ZM0.875305 8.28087L4.40173 11.102L5.65112 9.54027L2.1247 6.71913L0.875305 8.28087ZM8.5057 10.7663L16.2433 2.16896L14.7567 0.831035L7.01911 9.42837L8.5057 10.7663ZM4.40173 11.102C5.6427 12.0948 7.44256 11.9476 8.5057 10.7663L7.01911 9.42837C6.66473 9.82212 6.06478 9.8712 5.65112 9.54027L4.40173 11.102Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.dfbaad90edb0edc8bb046c50d7962113.svg";
export { ForwardRef as ReactComponent };